module.exports = __webpack_public_path__ + "img/yalda_nemala_no.9b4ace13.png";